import { useState } from 'react'
import { HIGHLIGHT_TAG_MAP } from '../../../../../model/caf.interface'
import { useCafHighlightV5 } from '../../../../../modules/apis/webview/caf'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import useRNMsg, { ringleAppNavs } from '../../../../../modules/hooks/webview/common/useRNMsg'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import { PronunciationHighlightDetail } from '../../../../new-portal/caf/CAFOverview/popup/useHighlightDetailSidePopup'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIStatisticHighlightDetailListActivity = ({ params }) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { highlightId, tag, errorId } = params
  const { t } = useTranslation()
  const { sendPostMsg } = useRNMsg()
  const [showPopup, setShowPopup] = useState(false)
  const isMobile = useIsMobile()
  const { data, error, refetch, isLoading } = useCafHighlightV5(+highlightId)
  const handleClickErrorReport = (contentId, contentSentence) => () => {
    if (isMobile) {
      sendPostMsg({
        nav: ringleAppNavs.cafErrorReport,
        detail_id: contentId,
        detail_content: contentSentence,
        from: 'highlight',
      })
    } else {
      setShowPopup(true)
    }
  }
  const highlightDetail = data
    ? {
        ...data?.pages[0],
        details: data?.pages?.reduce((ac, cr) => {
          return [...ac, ...cr.details]
        }, []),
      }
    : null
  const selectedSentence = highlightDetail?.details.find((detail) => Number(detail.id) === Number(errorId))

  return (
    <div>
      <WebviewStackContainer height="52px" onBack={pop} border={true}>
        {isLoading || !data ? (
          <div className="h-screen">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="bg-gray-50 px-[20px] pt-[16px]">
            {+tag === HIGHLIGHT_TAG_MAP.pronunciation && (
              <PronunciationHighlightDetail
                detail={selectedSentence}
                contentId={errorId}
                handleClickErrorReport={handleClickErrorReport}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
              />
            )}
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIStatisticHighlightDetailListActivity
